import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import CardDefault from "../../../../components/ui/cards/card-default/card-default";
import IconDescription from "../../../../components/ui/icon-description/icon-description";
import "./consultancy-competence.scss";

const ConsultancyCompetence = () => {
  return (
    <section className="consultancy-competence">
      <Fade direction="up" duration={600} triggerOnce>
        <IntroSectionBadge
          title={"Ambiti Operativi"}
          text={
            "Operiamo in diversi settori dell’edilizia, gestendo la parte esecutiva e coordinando le attività con i tecnici incaricati"
          }
          bgColor={"light"}
        />
      </Fade>
      <Fade direction="up" duration={900} cascade damping={0.2} triggerOnce>
        <div className="consultancy-competence__cards-list">
          <CardDefault type={"grey"} width="full-width">
            <IconDescription
              icon={"house"}
              title={"Residenziale"}
              text={"Ville, condomini e complessi abitativi"}
              type={"primary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
          <CardDefault type={"grey"} width="full-width">
            <IconDescription
              icon={"building"}
              title={"Commerciale"}
              text={"Centri commerciali e uffici"}
              type={"secondary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
          <CardDefault type={"grey"} width="full-width">
            <IconDescription
              icon={"industry"}
              title={"Industriale"}
              text={"Capannoni e impianti produttivi"}
              type={"secondary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
          <CardDefault type={"grey"} width="full-width">
            <IconDescription
              icon={"road"}
              title={"Infrastrutture"}
              text={"Ponti, strade e opere pubbliche"}
              type={"secondary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
        </div>
      </Fade>
    </section>
  );
};

export default ConsultancyCompetence;
